var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-scheduled",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Time",
    d: "M3.219,8.5A5.281,5.281,0,1,1,8.5,13.781,5.281,5.281,0,0,1,3.219,8.5ZM8.5,2A6.5,6.5,0,1,0,15,8.5,6.5,6.5,0,0,0,8.5,2Zm.609,2.966a.609.609,0,0,0-1.219,0V8.5a.609.609,0,0,0,.337.545l2.356,1.178a.609.609,0,0,0,.545-1.09L9.109,8.123Z",
    transform: "translate(-2 -2)",
    fill: "#333",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduled);
export default __webpack_public_path__ + "static/media/scheduled.c17d656d117f2e5756cb304d3768feab.svg";
export { ForwardRef as ReactComponent };